import unescapedText from 'I18n/utils/unescapedText';
import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import { useMemo } from 'react';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { SliderSection } from '../../components/SliderSection';
import { useAppContext } from '../../context/AppContext';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { LISTINGS_PER_PAGE } from '../../search-results/constants';

/** Feel free to tweak this! Higher values will fire the query higher up the page. */
import { jsx as _jsx } from "react/jsx-runtime";
const INTERSECTION_OFFSET = 256;
export function AllSection({
  productType
}) {
  const appContext = useAppContext();

  // in-app needs a special root element, b/c of the global nav
  const root = useMemo(() => appContext === 'app' ? document.querySelector('body > div.page') : undefined, [appContext]);
  return /*#__PURE__*/_jsx(IntersectionObserver, {
    root: root,
    rootMargin: `0px 0px ${INTERSECTION_OFFSET}px 0px`,
    renderContent: isIntersecting => /*#__PURE__*/_jsx(AllSectionContent, {
      visible: !!isIntersecting,
      productType: productType
    })
    // small optimization
    ,
    onIntersectionChange: ({
      entries,
      observer
    }) => {
      if (entries[0].isIntersecting) observer.disconnect();
    }
  });
}
export function AllSectionContent({
  visible,
  productType
}) {
  var _data$result$cards$sl;
  const {
    data,
    error
  } = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      skip: !visible,
      // keep these variables the same as useSearchResultsQuery,
      // so that we can take advantage of the caching!
      variables: {
        queryType: 'ELASTIC_SEARCH',
        length: LISTINGS_PER_PAGE,
        offset: 0,
        filter: {
          filterGroups: [{
            filtersByField: {
              PRODUCT_TYPE: [{
                values: [productType],
                clause: 'OR',
                negation: false,
                __typename: 'com.hubspot.marketplace.search.models.filters.StringFilterQuery'
              }]
            },
            clause: 'AND',
            negation: false
          }],
          clause: 'AND',
          negation: false
        }
      }
    }
  });

  // since this is non-essential, don't show if there's an error
  if (error) return undefined;
  return /*#__PURE__*/_jsx(SliderSection, {
    title: productType === 'APP' ? unescapedText('marketplaceStorefront.productHome.allApps') : unescapedText('marketplaceStorefront.productHome.allAgents'),
    seeMoreHref: `/explore?eco_PRODUCT_TYPE=${String(productType)}`,
    cards: (_data$result$cards$sl = data === null || data === void 0 ? void 0 : data.result.cards.slice(0, 10)) !== null && _data$result$cards$sl !== void 0 ? _data$result$cards$sl : [],
    loading: !data
  });
}